import { useState, useEffect } from 'react';

export function usePWA() {
  const [isStandalone, setIsStandalone] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkStandalone = () => {
      const isStandaloneMode =
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true || // For iOS
        document.referrer.includes('android-app://');

      setIsStandalone(!!isStandaloneMode);
    };

    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Simple check for mobile
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent,
      );
      setIsMobile(isMobileDevice);
    };

    checkStandalone();
    checkMobile();

    // Listen for changes
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handler = (e) => setIsStandalone(e.matches);

    try {
      mediaQuery.addEventListener('change', handler);
    } catch {
      // Fallback for older browsers
      mediaQuery.addListener(handler);
    }

    return () => {
      try {
        mediaQuery.removeEventListener('change', handler);
      } catch {
        mediaQuery.removeListener(handler);
      }
    };
  }, []);

  return { isStandalone, isMobile };
}
